<template>
  <Modal :title="title" :showModal="showModal" class="edit-term-form" @submit="submit">
    <template v-slot:body>
      <div class="row">
        <div class="position-relative form-group col-12">
          <span>ID:&nbsp;</span>
          <span class="select-all">{{ data.id }}</span>
        </div>
        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Name*</label>
          <input class="form-control mt-2" type="text" :value="data.name" @change.stop.prevent="changeName($event)" />
        </div>
        <div class="position-relative form-group attributes col-12">
          <label class="mb-0 p-0 text-capitalize">Default Attributes*</label>
          <div v-for="(attribute, key, index) in attributes" :key="index" class="attribute mt-2 mb-4">
            <div class="d-flex">
              <input class="form-control flex-1 mr-2" type="text" placeholder="Label" :value="attribute.label" @change.stop.prevent="changeAttributeLabel($event, key)" />
              <div class="input-group-append">
                <a href="#remove" class="btn-transition btn btn-outline-danger remove d-flex align-items-center" @click.stop.prevent="removeAttribute(key)">Remove</a>
              </div>
            </div>
            <Select placeholder="Attributes" data-title="Attributes" class="has-tip mt-2 mb-2" :value="attribute.fields || []" taggable multiple @changeValue="changeAttributeField($event, key)"></Select>
            <Select placeholder="Suggestions" data-title="Suggestions" class="has-tip mt-2 mb-2" :value="attribute.suggest || []" taggable multiple @changeValue="changeAttributeSuggest($event, key)"></Select>
            <input class="form-control flex-1 mr-2" type="text" placeholder="Default" :value="attribute.default" @change.stop.prevent="changeAttributeDefault($event, key)" />
          </div>
          <small class="font-italic text-muted d-block">Attributes are used to assign to orders when synchronized. The first attribute will be used as the main attribute</small>
          <a href="#add-more" class="btn btn-outline-primary add-more mt-2" @click.stop.prevent="addAttribute">Add More</a>
        </div>

        <div class="position-relative form-group col-12 d-flex flex-wrap">
          <label class="col-12 mb-0 p-0">Design Name Suggestion</label>
          <div class="col-6 pl-0 pr-1 mt-2">
            <input class="form-control has-tip" data-title="No Flag" placeholder="No Flag" type="text" :value="designSuggest.no_flag" @change.stop.prevent="store.commit('design_suggest.no_flag', $event.target.value)" />
          </div>
          <div class="col-6 pr-0 pl-1 mt-2">
            <input class="form-control has-tip" data-title="Has Flag" placeholder="Has Flag" type="text" :value="designSuggest.has_flag" @change.stop.prevent="store.commit('design_suggest.has_flag', $event.target.value)" />
          </div>
          <small class="mt-1 font-italic text-muted">Allow &#123;&#123;&#37; buyer_name &#37;&#125;&#125;, &#123;&#123;&#37; order_id &#37;&#125;&#125;, &#123;&#123;&#37; product_id &#37;&#125;&#125;, &#123;&#123;&#37; product_sku &#37;&#125;&#125;, &#123;&#123;&#37; [attribute name] &#37;&#125;&#125;. Example: Design &#123;&#123;&#37; order_id &#37;&#125;&#125; - &#123;&#123;&#37; product_id &#37;&#125;&#125; - &#123;&#123;&#37; style &#37;&#125;&#125;</small>
        </div>

        <div class="position-relative form-group col-12">
          <label class="col-12 mb-0 p-0">Relationships</label>
          <Select placeholder="Platform" class="mt-2" :options="platformOptions" v-model="platform"></Select>
          <Select v-show="platform != ''" placeholder="Relationships" class="mt-2" :loading="this.relationshipLoading" :options="relationshipOptions[platform]" :value="relationships" @changeValue="changeRelationships" ref="relationship" :multiple="true"></Select>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
export default {
  mixins: [Event],
  data() {
    return {
      platform: '',
      relationshipOptions: {},
      relationshipLoading: false
    }
  },
  computed: {
    title() {
      return 'Edit Category'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    termId() {
      return this.config?.data?._id
    },
    getUri() {
      return `term/get/${this.termId}`
    },
    getExternalTermUri() {
      return `term/external/get/${this.platform}`
    },
    submitUri() {
      return `term/update/${this.termId}`
    },
    data() {
      return this.store.getter('', {})
    },
    attributes() {
      let attributes = Object.values(this.data?.attributes || [])
      if (attributes.length == 0) {
        attributes.push({})
      }
      return attributes
    },
    designSuggest() {
      return Object.assign({}, this.data?.design_suggest) || {}
    },
    platformOptions() {
      let platforms = this.$util.options?.platforms || {}
      let options = []
      for (const [key, platform] of Object.entries(platforms)) {
        options.push({
          id: key,
          text: platform.label
        })
      }
      return options
    },
    relationships() {
      return Object.values(this.data?.relationships?.[this.platform] || [])
    }
  },
  created() {
    this.store.commit('', {})
  },
  methods: {
    changeName(e) {
      this.store.commit('name', e.target.value)
    },
    changeAttributeLabel(e, key) {
      this.store.commit(['attributes', key, 'label'], e.target.value)
    },
    changeAttributeDefault(e, key) {
      this.store.commit(['attributes', key, 'default'], e.target.value)
    },
    addAttribute() {
      let attributes = this.attributes
      attributes.push({})
      this.store.commit('attributes', Object.values(attributes))
    },
    removeAttribute(key) {
      let attributes = this.attributes
      if (attributes[key] != undefined) {
        delete attributes[key]
      }
      this.store.commit('attributes', Object.values(attributes))
    },
    changeAttributeField(values, key) {
      this.store.commit(['attributes', key, 'fields'], values)
    },
    changeAttributeSuggest(values, key) {
      this.store.commit(['attributes', key, 'suggest'], values)
    },
    changeRelationships(values) {
      if (this.relationshipOptions?.[this.platform] != undefined) {
        let relationships = Object.assign({}, this.data.relationships)
        relationships[this.platform] = Object.values(values).map((item) => String(item))
        this.store.commit('relationships', relationships)
      }
    },
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.showModal = true
        rawData.data.attributes = Object.values(rawData.data.attributes || [])
        this.store.commit('', rawData.data)
      }
    },
    submit() {
      this.submitForm(this.data, {
        done: () => {
          this.$emit('close')
          this.$emitter.emit('TableList.Refresh')
        }
      })
    }
  },
  props: {
    config: Object
  },
  watch: {
    platform(platform) {
      if (platform != '' && this.relationshipOptions[platform] == undefined) {
        this.relationshipLoading = true
        this.$util
          .get(this.getExternalTermUri, {}, this.$refs.relationship)
          .then((response) => {
            this.relationshipLoading = false
            if (response.status == 'success') {
              this.relationshipOptions[platform] = Object.values(response.data)
            }
          })
          .catch(() => {
            this.relationshipLoading = false
          })
      }
    }
  }
}
</script>
